import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutoPaddingKeyboardFocus]',
})
export class AutoPaddingKeyboardFocusDirective implements AfterViewInit {
  @Input() appAutoPaddingKeyboardFocus: string = '';

  constructor(private readonly el: ElementRef) {}

  ngAfterViewInit() {
    this.setPadding();
  }

  // This directive automatically adjusts the bottom padding of the element it is applied to when the keyboard is open, ensuring that the element remains visible and accessible. It does this by checking the height of a target element (specified by the `appAutoPaddingKeyboardFocus` input) and setting the bottom padding of the directive's host element accordingly. If the target element's height is not greater than 0, it retries after a short delay.

  private setPadding() {
    const targetElement = document.getElementById(this.appAutoPaddingKeyboardFocus);

    if (!targetElement) {
      return;
    }

    const targetHeight = targetElement.offsetHeight;

    if (targetHeight > 0) {
      this.el.nativeElement.style.paddingBottom = `${targetHeight}px`;
    } else {
      setTimeout(() => this.setPadding(), 100);
    }
  }
}
